import { translateDictionary } from './translate.dictionary'

export type { TranslationKey } from './translate.dictionary'

export const translate = (...keys: string[]) => {
  return keys.map(resolve).join(' ')
}

// Fills `{name}` placeholders in a dictionary entry.
export const translateTemplate = (key: string, values: Record<string, string | number>) =>
  resolve(key).replace(/\{(\w+)\}/g, (placeholder, name: string) =>
    name in values ? String(values[name]) : placeholder)

export const translatePlural = (
  count: number,
  oneKey: string,
  manyKey: string,
  values: Record<string, string | number> = {},
) => translateTemplate(count === 1 ? oneKey : manyKey, { count, ...values })

const resolve = (key: string) => {
  const value = translateDictionary[key]
  return value || key
}
